export class AuditLog{
    public AuditLogId:string;

    public AuditDate:string;

    public Entity:string;

    public Key:string;

    public Operation:string;
    
    public User:string;

    public AuditLogType:string;

    public Severity:string;

    public Message:string;

    public OriginalEntity:any;

    public NewEntity:any;

    public static readonly AuditLogTypeFullyQualifiedType:string = 'RCC.Model.Entities.AuditLogType';
    public static readonly AuditEntityFullyQualifiedType:string = 'RCC.Model.Entities.AuditEntity';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/audit-log.ts